module.exports = "<div class=\"modal-header\">\n  <h5 class=\"modal-title\" ng-bind=\"info.resolve.title | translate\"></h5>\n</div>\n<div class=\"modal-body\" ng-if=\"info.resolve.content\">\n  <p class=\"\" ng-bind=\"info.resolve.content | translate\"></p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"pull-right\">\n    <button\n      class=\"btn btn-flat\"\n      type=\"submit\"\n      ng-click=\"info.$onClose()\"\n      ng-bind=\"'OK' | translate\">\n    </button>\n  </div>\n  <div class=\"clearfix\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./sources/utility/info/info.html
// module id = 891
// module chunks = 0